<template>
  <v-dialog style="z-index: 99999 !important" v-model="show" fullscreen transition="dialog-bottom-transition" content-class="tiktok-dialog ">
    <div class="party-container" v-if="party">
      <div class="image-wrapper text-center">
        <img style="height: 150px; "  src="/img/roody_logo.png"></v-img>
      </div>

      <v-btn icon large class="close-btn" @click="close">
        <v-icon color="white">mdi-chevron-down</v-icon>
      </v-btn>

      <div class="content-area">
        <div class="event-meta mb-2">
          <v-chip color="rgba(0,150,63,0.4)" class="backdrop-blur mr-2" dark small>
            <v-icon left x-small>mdi-calendar</v-icon>
            {{ $moment(party.eventDate).format("DD. MMM YYYY") }}
          </v-chip>
          <v-chip color="rgba(0,150,63,0.4)" class="backdrop-blur" dark small>
            <v-icon left x-small>mdi-clock</v-icon>
            {{ $moment(party.eventDate).format("HH:mm") }} Uhr
          </v-chip>
          <v-chip v-if="party.location" color="rgba(0,150,63,0.4)" class="backdrop-blur ml-2" dark small>
            <v-icon left x-small>mdi-map-marker</v-icon>
            {{ party.location }}
          </v-chip>
        </div>

        <h1 class="event-title white--text">{{ party.title }}</h1>

        <div class="description-scroll white--text my-3" v-html="party.description"></div>
        <v-spacer></v-spacer>
        <div class="action-bar mt-4">
          <template v-if="party.allowSignup">
            <v-btn
              v-if="isFull && !isSignedUp"
              block
              x-large
              rounded
              disabled
              class="font-weight-bold grey--text text--lighten-1"
              style="background-color: rgba(255, 255, 255, 0.1) !important">
              <v-icon left>mdi-cancel</v-icon>
              Leider ausgebucht
            </v-btn>

            <v-btn
              v-else
              block
              x-large
              rounded
              :color="isSignedUp ? 'grey darken-3' : '#00963f'"
              class="white--text font-weight-bold pulse-animation-overlay"
              @click="toggleSignup"
              :loading="loading">
              <v-icon left>{{ isSignedUp ? "mdi-check" : "mdi-ticket-confirmation" }}</v-icon>
              {{ isSignedUp ? "Angemeldet" : "Jetzt teilnehmen" }}

              <span v-if="!isSignedUp && remainingSpots > 0 && remainingSpots <= 10" class="ml-2 text-caption">
                (Noch {{ remainingSpots }} Plätze)
              </span>
            </v-btn>
          </template>
          <div v-else class="text-center white--text font-italic caption mt-2">Keine Anmeldung erforderlich</div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import api from "../../api"
import confetti from "canvas-confetti"
import userService from "@/services/userService"
export default {
  props: ["value", "party", "user"],
  data() {
    return {
      userService,
      loading: false,
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
    isSignedUp() {
      if (!this.party || !this.party.signups || !this.userService.getUserId()) return false
      return this.party.signups.includes(this.userService.getUserId())
    },
    isFull() {
      if (!this.party || !this.party.maxSignups) return false
      return this.party.signups.length >= this.party.maxSignups
    },
    remainingSpots() {
      if (!this.party || !this.party.maxSignups) return 999
      return Math.max(0, this.party.maxSignups - this.party.signups.length)
    },
  },
  methods: {
    close() {
      this.show = false
    },
    async toggleSignup() {
      this.loading = true
      try {
        if (this.isSignedUp) {
          await api.signoffParty(this.party._id)
          this.$toast.info("Du hast dich erfolgreich abgemeldet.")
          this.party.signups = this.party.signups.filter((id) => id !== this.userService.getUserId())
        } else {
          if (this.isFull) {
            this.$toast.error("Sorry, das Event ist leider schon voll.")
            this.loading = false
            return
          }

          await api.signupParty(this.party._id)

          if (!this.party.signups) this.party.signups = []
          this.party.signups.push(this.userService.getUserId())

          this.triggerConfetti()
          this.$toast.success("Du bist dabei! Viel Spaß!")
        }
      } catch (e) {
        let msg = "Ein Fehler ist aufgetreten."
        if (e.response && e.response.data && typeof e.response.data === "string") {
          msg = e.response.data
        }
        this.$toast.error(msg)
      }
      this.loading = false
    },
    triggerConfetti() {
      var duration = 3 * 1000
      var animationEnd = Date.now() + duration
      var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 }

      var random = function (min, max) {
        return Math.random() * (max - min) + min
      }

      var interval = setInterval(function () {
        var timeLeft = animationEnd - Date.now()

        if (timeLeft <= 0) {
          return clearInterval(interval)
        }

        var particleCount = 50 * (timeLeft / duration)
        confetti({ ...defaults, particleCount, origin: { x: random(0.1, 0.3), y: Math.random() - 0.2 } })
        confetti({ ...defaults, particleCount, origin: { x: random(0.7, 0.9), y: Math.random() - 0.2 } })
      }, 250)
    },
  },
}
</script>

<style lang="scss" scoped>
.tiktok-dialog {
  background-color: #000 !important;
}

.party-container {
  position: relative;
  height: 100%;
  width: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Bild oben, Content unten */
}

/* WRAPPER FÜR 3:1 RATIO 
   Dieser Container behält immer exakt das Format 3:1 bei.
*/
.image-wrapper {
  position: relative;
  width: 100%;
  /* 100% Breite / 3 = 33.33% Höhe -> Ergibt exakt 3:1 */
  padding-top: 20%;
  padding-top: 7.5%;
  flex-shrink: 0; /* Verhindert, dass das Bild gestaucht wird */
  background-color: #000;
  overflow: hidden;
  z-index: 1;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* Hier der Trick für "Ganz drauf": */
  background-size: cover; /* Da der Wrapper exakt 3:1 ist, zeigt cover hier 100% des Bildes */
  background-position: center center;
  background-repeat: no-repeat;

  /* Animation beim Laden */
  animation: fade-in 0.8s ease-out;
}

/* Gradient, damit das Bild unten weich ins Schwarz übergeht */
.bg-overlay {
  position: absolute;
  bottom: 0; /* Klebt unten am Bildrand */
  left: 0;
  width: 100%;
  height: 10%; /* Gradient nimmt die untere Hälfte des Bildes ein */
  //background: linear-gradient(to bottom, transparent 0%, #000 100%);
  z-index: 2;
  pointer-events: none;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: scale(1.02);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50%;
}

.content-area {
  position: relative; /* Nicht mehr absolute, damit es nicht ins Bild rutscht, wenn Screens klein sind */
  width: 100%;
  padding: 20px 20px 40px 20px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  /* Hintergrund-Verlauf von unten nach oben, falls der Text lang ist */
  background: linear-gradient(to top, #000 90%, transparent 100%);

  /* Nimmt den restlichen Platz ein, schiebt Inhalt nach unten */
  flex-grow: 1;
  justify-content: flex-start;
}

.event-title {
  font-size: 2.2rem;
  line-height: 1.1;
  font-weight: 800;
  color: white;
  margin-bottom: 15px;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 1);
}

.event-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.description-scroll {
  max-height: 60vh; /* Großzügiger Platz für Text */
  overflow-y: auto;
  padding-right: 5px;
  color: #e0e0e0;
  font-size: 1rem;
  line-height: 1.5;

  ::v-deep p {
    margin-bottom: 5px !important;
  }

  /* Scrollbar Styling */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
  }
}

.backdrop-blur {
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  background-color: rgba(0, 150, 63, 0.3) !important;
}

/* Desktop Optimierung: Wenn der Screen sehr breit ist, begrenzen wir die Breite des Dialog-Inhalts, damit das Bild nicht riesig wird */
@media (min-width: 960px) {
  .party-container {
    margin: 0 auto;
    border-left: 1px solid #222;
    border-right: 1px solid #222;
  }
}

.pulse-animation-overlay {
  animation: pulse-overlay 2s infinite;
  box-shadow: 0 0 0 0 rgba(0, 150, 63, 0.7);
}

@keyframes pulse-overlay {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 150, 63, 0.7);
  }
  70% {
    transform: scale(1.02);
    box-shadow: 0 0 0 10px rgba(0, 150, 63, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 150, 63, 0);
  }
}
</style>
